import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './faq.module.css';

const ConditionDescription = () => {
  return (
    <div className={css.conditionDescription}>
      <p>
        <FormattedMessage id="faq.condition.describeCondition.confirm" />
      </p>
      <p>
        <FormattedMessage id="faq.condition.describeCondition.choose" />
      </p>
      <ul className={css.bulletList}>
        <li>
          <FormattedMessage
            id="faq.condition.describeCondition.newWithTags"
            values={{
              b: chunks => <strong>{chunks}</strong>,
            }}
          />
        </li>
        <li>
          <FormattedMessage
            id="faq.condition.describeCondition.newWithoutTags"
            values={{
              b: chunks => <strong>{chunks}</strong>,
            }}
          />
        </li>
        <li>
          <FormattedMessage
            id="faq.condition.describeCondition.likeNew"
            values={{
              b: chunks => <strong>{chunks}</strong>,
            }}
          />
        </li>
        <li>
          <FormattedMessage
            id="faq.condition.describeCondition.veryGood"
            values={{
              b: chunks => <strong>{chunks}</strong>,
            }}
          />
        </li>
        <li>
          <FormattedMessage
            id="faq.condition.describeCondition.good"
            values={{
              b: chunks => <strong>{chunks}</strong>,
            }}
          />
        </li>
        <li>
          <FormattedMessage
            id="faq.condition.describeCondition.satisfactory"
            values={{
              b: chunks => <strong>{chunks}</strong>,
            }}
          />
        </li>
      </ul>
      <p>
        <FormattedMessage
          id="faq.condition.describeCondition.additionalInfo"
          values={{
            b: chunks => <strong>{chunks}</strong>,
          }}
        />
      </p>
    </div>
  );
};

export default ConditionDescription;
